/**
 * This function returns applicable offers Data
 * @param {Product} product
 * @param {number} selectedSize
 * @returns {Offers}
 */
/* eslint-disable complexity */
function getBadgeInformation(product, selectedSize) {
  if (Object.keys(product).length === 0) return [];
  const selectedSizePresent = selectedSize !== undefined;

  if (!product.detail?.flags?.consolidatedProductComplex || !selectedSizePresent || product.detail?.flags?.isConsolidatedThirdVariant) {
    const isPriceDefined = !(product.pricing === undefined);
    const badgesMap = (isPriceDefined && !(product.pricing.badgesMap === undefined)) ? product.pricing.badgesMap : {};

    if (!isPriceDefined || Object.keys(badgesMap).length === 0) {
      return [];
    }

    return product.pricing.badgeIds.map((badgeId) => badgesMap[badgeId]);
  }

  const sizeMap = product.traits.sizes?.sizeMap || {};

  if (!Object.keys(sizeMap).length) {
    return [];
  }

  const size = Object.values(sizeMap)[selectedSize];

  const badgesMap = size.pricing?.badgesMap || {};

  if (Object.keys(badgesMap).length === 0) {
    return [];
  }

  return sizeMap[`${selectedSize}`].pricing.badgeIds.map((badgeId) => badgesMap[badgeId]);
}

export default getBadgeInformation;
